import {API_URLS, SERVICES} from '@/const';
import {http} from '@/helper';

const langMap = {
  cn: 'zh',
};

export const announcementApi = {
  recent() {
    return http.get(API_URLS.ANNOUNCEMENTS_RECENT, {});
  },
  contentViewLogout(query) {
    query.lang = langMap[query.lang] || query.lang;
    return http.get(API_URLS.ACTIVITY_CONTENTS_VIEW_LOGOUT, {
      query,
      formatter(data) {
        const {total, rows, unreadCount} = data;
        rows.forEach((row) => {
          row.detail.webimg = SERVICES.STATIC_URL + row.detail.webimg;
          row.detail.appimg = SERVICES.STATIC_URL + row.detail.appimg;
        });
        return {total, rows, unreadCount};
      },
    });
  },
  contentViewLogin(query) {
    query.lang = langMap[query.lang] || query.lang;
    return http.get(API_URLS.ACTIVITY_CONTENTS_VIEW_LOGIN, {
      query,
      formatter(data) {
        const {total, rows, unreadCount} = data;
        rows.forEach((row) => {
          row.detail.webimg = SERVICES.STATIC_URL + row.detail.webimg;
        });
        return {total, rows, unreadCount};
      },
    });
  },
  getBannerList(isLogin, query) {
    query.lang = langMap[query.lang] || query.lang;
    return http.get(isLogin ? API_URLS.ACTIVITY_CONTENTS_VIEW_LOGIN : API_URLS.ACTIVITY_CONTENTS_VIEW_LOGOUT, {
      query,
      formatter(data) {
        const {total, rows} = data;
        rows.forEach((row) => {
          row.detail.webimg = SERVICES.STATIC_URL + row.detail.webimg;
          row.detail.imageUrl = SERVICES.STATIC_URL + row.detail.imageUrl;
        });
        return {total, rows};
      },
    });
  },
  browseTime(query) {
    return http.put(API_URLS.BROWSE_TIME, {query});
  },
};
